var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",attrs:{"id":"signOut"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#13670B"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }